import { GzRadioWebComponent } from '../component/GzRadioWebComponent';

export class RadioSelection {
  public previousIndex = this.radios?.length - 1;
  public nextIndex = 1;
  public currentIndex = 0;
  public radio: GzRadioWebComponent;

  constructor(public radios: Array<GzRadioWebComponent>) {
    if (radios?.length) {
      this.setupSelection(radios);
    }
  }

  private setupSelection(radios: Array<GzRadioWebComponent>): void {
    const numberOfRadios = radios.length;
    const firstRadio = radios[0];

    this.radio = firstRadio;

    for (let i = 0; i < numberOfRadios; i++) {
      const { checked } = radios[i];

      if (checked) {
        const radio = radios[i];

        this.radio = radio;
        this.setConfig(numberOfRadios, i);

        break;
      }
    }
  }

  public setConfig(numberOfRadios: number, currentIndex: number): void {
    this.currentIndex = currentIndex;
    this.previousIndex = currentIndex === 0 ? numberOfRadios - 1 : currentIndex - 1;
    this.nextIndex = currentIndex === numberOfRadios - 1 ? 0 : currentIndex + 1;
  }
}

export enum RadioSelectionKey {
  PREVIOUS_INDEX = 'previousIndex',
  NEXT_INDEX = 'nextIndex',
}

export enum RadioEvent {
  SELECTION_CHANGED = 'radioSelectionChanged',
}
